<template>
  <div>
    <rest-list :payload="fetchEndpoint" :loading="isLoading">
      <rest-list-column
        prop="campaign_id"
        :title="$t('CampaignAuditLog_Field_CampaignId')"
        :width="150"
        :sortable="false"
      />
      <rest-list-column-date
        prop="create_time"
        :title="$t('CampaignAuditLog_Field_Date')"
        :width="200"
      />
      <rest-list-column-enum
        :sortable="false"
        prop="action"
        :title="$t('CampaignAuditLog_Field_Action')"
        :enum="AuditLogAction"
        :min-width="250"
        :show-overflow-tooltip="true"
      >
        <template v-slot="{ row }">
          {{ $t(AuditLogActionLabel[row.action]) }}
          <template v-if="row.action !== 'delete'">
            <!-- eslint-disable-next-line -->
            <router-link
              :data-qa="
                `campaign_audit_log_row_${formatDataQa(row.campaign_title)}`
              "
              :to="generateRoute(row.campaign_id, row.create_time)"
              >{{ row.campaign_title }} (#{{ row.campaign_id }})</router-link
            >
          </template>
          <template v-else>
            {{ row.campaign_title }} (#{{ row.campaign_id }})
          </template>
          <template v-if="row.changed_tabs">
            {{ getChangedTabs(row.changed_tabs) }}
          </template>
        </template>
      </rest-list-column-enum>
      <rest-list-column-enum
        :sortable="false"
        prop="source"
        :title="$t('CampaignAuditLog_Field_Source')"
        :enum="AuditLogSource"
      />
      <rest-list-column
        :sortable="false"
        :filterable="false"
        :filter-input="false"
        prop="updated_by"
        :title="$t('CampaignAuditLog_Field_UpdatedBy')"
      />
    </rest-list>
  </div>
</template>

<script>
import RestList from '@/common/components/rest/RestList'
import RestListColumn from '@/common/components/rest/RestListColumn'
import RestListColumnDate from '@/common/components/rest/RestListColumnDate'
import { projectEndpoint, projectRoute } from '@/core/helpers'
import { EventBus } from '@/core/EventBus'
import {
  AuditLogSource,
  AuditLogAction,
  AuditLogActionLabel
} from '@/modules/audit-log/enum/AuditLog'
import RestListColumnEnum from '@/common/components/rest/RestListColumnEnum'
export default {
  name: 'CampaignAuditLog',
  components: {
    RestListColumnEnum,
    RestListColumnDate,
    RestListColumn,
    RestList
  },
  data() {
    return {
      AuditLogSource,
      AuditLogAction,
      AuditLogActionLabel,
      isLoading: false
    }
  },
  mounted() {
    EventBus.$on('setLoading', isLoading => {
      this.isLoading = isLoading
    })
  },
  computed: {
    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `auditlog/campaigns`,
        params: {}
      })
    }
  },
  methods: {
    // eslint-disable-next-line camelcase
    generateRoute(id, create_time) {
      return projectRoute({
        name: 'ViewCampaignSnapshot',
        query: { id, create_time }
      })
    },
    getChangedTabs(tabs) {
      return tabs.map(tab => this.$t(`CampaignAuditLog_Tab_${tab}`)).join(' & ')
    },
    formatDataQa(campaignTitle) {
      return campaignTitle.replace(/ /g, '_').replace(/\W/g, '')
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/modules/audit-log/pages/CampaignAuditLog.vue